'use client'

import { useLocale } from 'next-intl'
import { useMemo } from 'react'
import { getPublicSeoOrigin } from '@/i18n/urls'
import {
  buildBreadcrumbListJsonLd,
  type BreadcrumbListItem,
} from './buildBreadcrumbListJsonLd'

type BreadcrumbJsonLdProps = {
  data: BreadcrumbListItem[]
  currentHref: string
}

export default function BreadcrumbJsonLd({
  data,
  currentHref,
}: BreadcrumbJsonLdProps) {
  const locale = useLocale()

  const jsonLd = useMemo(() => {
    const baseUrl = getPublicSeoOrigin()
    if (!baseUrl || !data?.length || !currentHref) return null
    return buildBreadcrumbListJsonLd({
      items: data,
      baseUrl,
      locale,
      currentHref,
    })
  }, [data, currentHref, locale])

  if (!jsonLd) return null

  return (
    <script
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  )
}
